import { motion } from "framer-motion";
import { CalendarDays, Footprints, Users, MapPin } from "lucide-react";
import CAMPAIGN from "@/data/campaign";

const ICONS = { calendar: CalendarDays, footprints: Footprints, users: Users, mappin: MapPin };

const QuickFacts = () => (
  <section className="bg-[#1A362B] text-[#F5F2EB]" data-testid="quick-facts">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-8 grid grid-cols-2 lg:grid-cols-4 gap-6">
      {CAMPAIGN.quickFacts.map((f, i) => {
        const Icon = ICONS[f.icon] || MapPin;
        return (
          <motion.div
            key={f.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1], delay: i * 0.08 }}
            className="flex items-center gap-4"
            data-testid={`quick-fact-${i}`}
          >
            <Icon className="w-6 h-6 text-[#B7E4BD] shrink-0" />
            <div>
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#F5F2EB]/55">{f.label}</p>
              <p className="text-sm md:text-base font-medium mt-0.5">{f.value}</p>
            </div>
          </motion.div>
        );
      })}
    </div>
  </section>
);

export default QuickFacts;
